<script lang="ts">
  import { Rive } from "@rive-app/canvas-lite";
  import StaticRoundel from "./static-roundel.svelte";

  interface Props {
    animate: boolean;
    size?: number;
    thin?: boolean;
  }

  let { animate, size = 16, thin = false }: Props = $props();

  let riveInstance: Rive | null;
  // svelte-ignore state_referenced_locally
  let showStaticRoundel = $state(!animate);

  function cleanup() {
    riveInstance?.cleanup();
    riveInstance = null;
  }

  function handleLoop() {
    // wait for the last loop to finish
    // then switch over to the static glyph
    if (!animate) {
      showStaticRoundel = true;
      cleanup();
    }
  }

  function handleLoadError() {
    showStaticRoundel = true;
    cleanup();
  }

  let loaded = $state(false);

  function action(node: HTMLCanvasElement) {
    if (!animate) return {};

    // @ts-ignore
    const riveUri = window.riveUri || "/roundel-spinner.riv";
    // @ts-ignore
    const riveThinUri = window.riveThinUri || "/roundel-spinner-thin.riv";

    riveInstance = new Rive({
      src: thin ? riveThinUri : riveUri,
      canvas: node,
      autoplay: true,
      onLoad: () => {
        riveInstance?.resizeDrawingSurfaceToCanvas();
        loaded = true;
      },
      onLoop: handleLoop,
      onLoadError: handleLoadError,
    });

    return {
      destroy() {
        cleanup();
      },
    };
  }
</script>

<div
  aria-hidden="true"
  class="relative flex items-center justify-center"
  style="width: {size}px; height: {size}px;"
>
  {#if !showStaticRoundel}
    <canvas
      use:action
      width={size}
      height={size}
      class="size-4 contain-strict dark:brightness-40 dark:hue-rotate-130 dark:invert dark:saturate-60 {loaded
        ? 'opacity-100'
        : 'opacity-0'}"
      style="width: {size}px; height: {size}px;"
    ></canvas>

    {#if !loaded}
      <StaticRoundel class="absolute" style="transform: translateZ(0)" {size} {thin} />
    {/if}
  {:else}
    <StaticRoundel {size} {thin} />
  {/if}
</div>
